import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';

import useCustomLayout from 'hooks/useCustomLayout';
import CarouselAutoplay from './CarouselAutoplay';

import { MENU_PLACEMENT, LAYOUT } from 'constants.js';

import Maccalli from './Maccalli';


const FooterBarMaccalli = () => {
  const title = 'Welcome to S.M.A.';
  const description = 'Father Maccalli Released!';
  const breadcrumbs = [{ to: '', text: 'Father Maccalli Released!' }];

 

  useCustomLayout({ placement: MENU_PLACEMENT.Horizontal, layout: LAYOUT.Boxed });
return (
    <>

      <Row>
        <Col>
          {/* Carousel Start */}
          <section className="scroll-section" id="carousel">
          <Row xxl="1">
              <Col xs="auto" sm="auto" className="mb-5">
               <CarouselAutoplay />
               </Col>
           </Row>
             </section>
          {/* Carousel End */}

      

     

          {/* Product Start */}
          <section className="scroll-section" id="Maccalli">
          <div className="cta-2 mb-5">
            <h2 className="small-title">Father Maccalli Released!</h2>
            </div>
            <div className="mb-5">
              <Maccalli />
            </div>
          </section>
          {/* Product End */}


       
        </Col>

      </Row>
    </>
  );

};

export default FooterBarMaccalli;
